import React, { useState } from "react";
import {
  Card,
  CardContent,
  Typography,
  Box,
  useTheme,
  useMediaQuery,
  Dialog,
  IconButton,
} from "@mui/material";
import TicketCard from "./TicketCard";
import { useDispatch } from "react-redux";
import CloseIcon from "@mui/icons-material/Close";
import { getAttendeeAccessPass } from "../../../../Redux/Reducers/communityReducer";

const SidebarEventCard = ({ event }) => {
  const dispatch = useDispatch();
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));
 const [showTicketCard, setShowTicketCard] = useState(false);
  // Format date to "DD Month YYYY" format
  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const day = date.getUTCDate().toString().padStart(2, "0");
    const monthNames = [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ];
    const month = monthNames[date.getUTCMonth()];
    const year = date.getUTCFullYear();
    return `${day} ${month} ${year}`;
  };

  // Extract ticket ID from registration object
  const ticketId = event?.registration?.ticket_id || event.event_code;

  // console.log("ticketIdNNNN", ticketId)

  // Use feature_image or fallback
  const imageUrl =
    event?.feature_image || "https://via.placeholder.com/100x100?text=Event";

    const handleCardClick=(ticketId)=>{
      dispatch(getAttendeeAccessPass(ticketId));
          // console.log("Card clicked");
          setShowTicketCard(true);
    }

    const handleCloseTicketCard = () => {
  setShowTicketCard(false);
};

  return (

    <Card
      sx={{
        display: "flex",
        flexDirection: "row",
        alignItems: "stretch",
        width: "95%", // Take full width of parent
        borderRadius: 3,
        boxShadow: "0 4px 12px rgba(0,0,0,0.08)",
        border: "0.5px solid #d1d5db",
        bgcolor: "background.paper",
        overflow: "hidden",
        mb: 1,
        // padding:'5px'
      }}
      onClick={() => handleCardClick(ticketId)}
    >
      {/* Left: Image */}
      <Box
        sx={{
          minWidth: 110,
          width: 110,
          height: 110,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          bgcolor: "#f5f5f5",
          borderRadius: "16px",
          overflow: "hidden",
          m: 2,
          flexShrink: 0,
        }}
      >
        <img
          src={imageUrl}
          alt={event?.title}
          style={{
            width: "100%",
            height: "100%",
            objectFit: "cover",
            borderRadius: 16,
          }}
        />
      </Box>

      <Box
        sx={{
          position: "relative",
          width: 20,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          my: 2
        }}
      >
        {/* Dashed line only */}
        <Box
          sx={{
            width: 0,
            height: "100%",
            borderLeft: "2px dashed #d1d5db",
            zIndex: 0,
          }}
        />
      </Box>

      {/* Right: Event Info */}
      <CardContent
        sx={{
          p: 0,
          pl: 1.5,
          pr: 2,
          flex: 1,
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          // mt:2
          padding:"10px"
        }}
      >
        {/* Title */}
        <Typography
          variant="h6"
          component="div"
          sx={{
            fontWeight: 700,
            mb: 0.5,
            fontSize: isSmallScreen ? "1.1rem" : "1.2rem",
            lineHeight: 1,
            fontSize:"14px"
          }}
        >
          {event?.title}
        </Typography>

        {/* Date */}
        <Typography
          variant="body2"
          color="text.secondary"
          sx={{ mb: 0.5, fontWeight: 500 }}
        >
          {formatDate(event?.start_time)}
        </Typography>

        {/* Location */}
        <Typography
          variant="body2"
          color="text.secondary"
          sx={{
            mb: 0.5,
            fontWeight: 500,
            display: "-webkit-box",
            WebkitLineClamp: 2,
            WebkitBoxOrient: "vertical",
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "normal",
            maxWidth: 180,
          }}
          title={event?.event_location}
        >
          {event?.event_location ||
            (event?.mode === "Online"
              ? "Online Event"
              : "Location not specified")}
        </Typography>

        {/* Ticket ID */}
        <Typography
          variant="caption"
          color="text.secondary"
          sx={{
            display: "block",
            // mb: 1,
            fontWeight: 500,
          }}
        >
          Ticket ID: {ticketId}
        </Typography>
      </CardContent>

      <Dialog
        open={showTicketCard}
        onClose={handleCloseTicketCard}
        maxWidth="sm"
        fullWidth
        PaperProps={{
          sx: {
            background: "rgba(255,255,255,0.1)",
            backdropFilter: "blur(16px)",
            boxShadow: 24,
            borderRadius: 2,
            p: 0,
            minHeight: "80vh",
            width: "30%",
            scrollbarWidth: "none",
            position: "relative",
          },
          elevation: 0,
        }}
        sx={{
          "& .MuiDialog-container": {
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            backdropFilter: "blur(8px)",
            background: "rgba(0,0,0,0.3)",
          },
        }}
      >
        <Box
          sx={{ position: "relative", width: "100%", p: 0 }}
          onClick={e => e.stopPropagation()} // Prevent click bubbling
        >
          <IconButton
            aria-label="close"
            onClick={handleCloseTicketCard}
            sx={{
              position: "absolute",
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
              zIndex: 10,
            }}
          >
            <CloseIcon />
          </IconButton>
          <Box sx={{ display: "flex", justifyContent: "center", p: 0 }}>
            <TicketCard event={event} onClose={handleCloseTicketCard} />
          </Box>
        </Box>
      </Dialog>
    </Card>
  );
};

export default SidebarEventCard;
